export default __webpack_public_path__ + "static/kwil-9363bec3527e262821d1562f11d775c7.svg";